import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { NetAuthProvider } from '@/contexts/NetAuthContext';
import { installChunkReloadHandler } from '@/lib/chunkReload';
import './index.css';

installChunkReloadHandler();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <NetAuthProvider>
          <App />
        </NetAuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
